import { Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpContext } from "@angular/common/http";
import { IGNORE_ERROR_HANDLING } from "../../util/interceptors";
import { UrlService } from "../../../environments/urlService";

@Injectable({
  providedIn: 'root',
})
export class IpApiService {
  private http = inject(HttpClient);
  private urlService = inject(UrlService);
  private readonly url: string;

  constructor() {
    this.url = this.urlService.getModelsUrl() + 'ipapi/';
  }

  public getCountryName(): Observable<IpLocationResponse> {
    return this.http.get<IpLocationResponse>(this.url + 'location-info', {
        context: new HttpContext().set(IGNORE_ERROR_HANDLING, true),
        withCredentials: true,
      });
  }
}

export interface IpLocationResponse {
  country: string;
  callingCode: string;
}
